export default "__VITE_ASSET__uRazHB8v__"